import type { SVGProps } from "react";
const SvgCircleArrowRight01Sharp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <circle
      cx={10}
      cy={10}
      r={8.333}
      stroke="currentColor"
      strokeWidth={1.25}
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.25}
      d="m8.75 13.333 2.313-3.083a.42.42 0 0 0 0-.5L8.75 6.667"
    />
  </svg>
);
export default SvgCircleArrowRight01Sharp;
